/**
 * 设置cookie
 * @description < 登录时，写入cookie >
 */
export function setCookie(name, value, expiremMinutes) {
  const exDate = new Date();
  exDate.setTime(exDate.getTime() + expiremMinutes * 60 * 1000);
  document.cookie = `${name}=${escape(value)}${(expiremMinutes == null) ? '' : `;expires=${exDate.toGMTString()}`}`;
}
/**
* 读取cookie
* @description < 点击保存密码时，读取cookie >
*/
export function getCookie(name) {
  if (document.cookie.length > 0) {
    let start = document.cookie.indexOf(`${name}=`);
    if (start !== -1) {
      start = start + name.length + 1;
      let end = document.cookie.indexOf(';', start);
      if (end === -1) {
        end = document.cookie.length;
        return unescape(document.cookie.substring(start, end));
      }
    }
  }
  return '';
}
/**
* 删除cookie
* @description < 未点击保存密码时，删除cookie >
*/
export function delCookie(name) {
  const exp = new Date();
  exp.setTime(exp.getTime() - 1);
  const cval = getCookie(name);
  if (cval != null) {
    document.cookie = `${name}=${cval};expires=${exp.toGMTString()}`;
  }
}
// 开始日期显示范围
export const pickerOptionStart = {
  // 日期范围控制在今天之前三个月之内
  disabledDate(time) {
    const curDate = (new Date()).getTime();
    const three = 90 * 24 * 3600 * 1000;
    const threeMonths = curDate - three;
    return time.getTime() > Date.now() || time.getTime() < threeMonths;
  },
  shortcuts: [{
    text: '今天',
    onClick(picker) {
      picker.$emit('pick', new Date());
    },
  }, {
    text: '昨天',
    onClick(picker) {
      const date = new Date();
      date.setTime(date.getTime() - 3600 * 1000 * 24);
      picker.$emit('pick', date);
    },
  }, {
    text: '一周前',
    onClick(picker) {
      const date = new Date();
      date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
      picker.$emit('pick', date);
    },
  }],
};
export function getFormatDay(num, str) {
  const today = new Date();
  const nowTime = today.getTime();
  const ms = 24 * 3600 * 1000 * num;
  today.setTime(parseInt(nowTime + ms));
  const oYear = today.getFullYear();
  let oMoth = (today.getMonth() + 1).toString();
  if (oMoth.length <= 1) oMoth = `0${oMoth}`;
  let oDay = today.getDate().toString();
  if (oDay.length <= 1) oDay = `0${oDay}`;
  return oYear + str + oMoth + str + oDay;
}
// -------------------------------------------打印
/**
 * 打印页面数据
 * @param {String} content html流
 * @param {*} w 长度
 * @param {*} h 高度
 */
export function print(content, footer = '', isRow = true, w = null, h = null) {
  content += footer;
  const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
  const dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;
  const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
  const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
  w = +w === 0 ? width : w;
  h = +h === 0 ? height : h;
  const left = ((width / 2) - (w / 2)) + dualScreenLeft;
  const top = ((height / 2) - (h / 2)) + dualScreenTop;
  const myWindow = window.open('', '打印', `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=yes, copyhistory=no, width=${w}, height=${h}, top=${top}, left=${left}`);
  // 打印表格样式
  const style = "<style type='text/css'>.title {font-size: 30px;text-align: center; margin-bottom: 15px} .head{width: 100%; display: flex; justify-content: space-between;margin-bottom: 15px} .divFooter{position: fixed; display: flex; justify-content: space-between;bottom: 0;}.divFooter>div{margin-right: 100px} table{width: 100%} table.el-table__body {width: 600px;font-family: verdana,arial,sans-serif;font-size:11px;color:#333333;border-width: 1px;border-color: #666666;border-collapse: collapse}table.el-table__body, table.el-table__header th {border-width: 1px;padding: 5px;border-style: solid;border-color: #666666;background-color: #dedede}table.el-table__body td {border-width: 1px;padding: 5px;border-style: solid;border-color: #666666;background-color: #ffffff}}</style>";
  myWindow.document.write(content + style);
  myWindow.focus();
  myWindow.document.close(); // 关闭document的输出流, 显示选定的数据
  myWindow.print.portrait = isRow;
  myWindow.print(); // 打印当前窗口
  return myWindow;
}



// WEBPACK FOOTER //
// ./src/assets/common/common.js